
import Vue from "vue"
import FooterBase from "~/components/base/footerBase"

export default Vue.extend({
  name: "TheFooter",
  extends: FooterBase
  // TODO Tracking should be added to click on PhoneNumber
})
